/**
 * Phase 3 — Insurance carrier rate table.
 *
 * Thin vertical wrapper around the shared `<PartnerRateTable />`
 * engine that hardcodes `category="insurance"`. Phase 3's goal is to
 * give insurance a dedicated, named component file so editors and
 * AI tools (grep, refactor, semantic search) get a clean "this is
 * THE insurance table" signal — instead of a generic "LenderRate"
 * branded shared monolith.
 *
 * Future Phase 3.x: pull the insurance-specific row rendering out of
 * the engine and into this component. For now the engine stays the
 * implementation; consumers just import the named wrapper instead of
 * passing `category="insurance"` to a misnamed shared component.
 */
import React from "react";
import PartnerRateTable from "../PartnerRateTable";
import { INSURANCE_CONFIG } from "../../features/insurance/config";

export default function InsuranceCarrierTable({
  sourcePage,
  title,
  subtitle,
  limit = 10,
  creditMax,
  creditMin,
  onListChange,
  enableFilters = false,
  compactHeader = false,
  suppressMethodologyBadge = false,
}) {
  return (
    <div data-testid="insurance-carrier-table">
      <PartnerRateTable
        category="insurance"
        sourcePage={sourcePage}
        title={title || INSURANCE_CONFIG.rateTable.headerLabel}
        subtitle={subtitle}
        limit={limit}
        creditMax={creditMax}
        creditMin={creditMin}
        onListChange={onListChange}
        enableFilters={enableFilters}
        compactHeader={compactHeader}
        suppressMethodologyBadge={suppressMethodologyBadge}
      />
    </div>
  );
}
